import { isNotNilOrEmpty } from '@pcty/utils';
export var _handleInputFocused = function (_a) {
    var clearInputOnFocus = _a.clearInputOnFocus, focused = _a.focused, inputValue = _a.inputValue, setInputFocused = _a.setInputFocused, setInputValue = _a.setInputValue, value = _a.value;
    if (focused && clearInputOnFocus) {
        setInputValue('');
    }
    else if (!focused && value && value.label && inputValue !== value.label) {
        if (value.label) {
            setInputValue(value.label);
        }
    }
    setInputFocused(focused);
};
export var _handleInputOnSearch = function (_a) {
    var debouncedSearch = _a.debouncedSearch, filterTyping = _a.filterTyping, inputValue = _a.inputValue, readOnly = _a.readOnly, setInputValue = _a.setInputValue, persistedInputValue = _a.persistedInputValue, setPersistedInputValue = _a.setPersistedInputValue, setFilterTyping = _a.setFilterTyping, setFocusedRow = _a.setFocusedRow, setListDataArraySwitch = _a.setListDataArraySwitch, searchable = _a.searchable, value = _a.value;
    if (readOnly)
        return;
    var inputVal = inputValue;
    var searchTerm = '';
    var checkInputValue = function () {
        var _a;
        var valueCheck = '';
        if (value.label) {
            valueCheck = value.label;
        }
        else if ((_a = value[0]) === null || _a === void 0 ? void 0 : _a.label) {
            valueCheck = value[0].label;
        }
        return inputVal.substring(1) === valueCheck;
    };
    var userTyping = false;
    /**
     * whatever the user types, we set the inputvalue to that
     */
    if (value && checkInputValue()) {
        /**
         * here we check if a space is passed in, if so, clear the input, we dont want spaces
         */
        if (inputVal.substring(0, 1).trim().length > 0) {
            inputVal = inputVal.substring(0, 1);
        }
        else {
            inputVal = '';
        }
    }
    searchTerm = inputVal === (value === null || value === void 0 ? void 0 : value.label) ? '' : inputVal;
    userTyping = isNotNilOrEmpty(searchTerm);
    // reset the focus row on every search
    setFocusedRow(null);
    setInputValue(inputVal);
    if (persistedInputValue) {
        setPersistedInputValue('');
    }
    if (searchable) {
        if (!filterTyping) {
            setFilterTyping(true);
        }
        // update the listDataArray
        setListDataArraySwitch(true);
    }
    /*
       debating whether or not to lock this behind the searchable bool, as they can just not pass anything into the onInputSearch prop.
       i can see a case where they filter internally, and then async search, that overwrites the value...
     */
    debouncedSearch(searchTerm, userTyping);
};
export var resetInputValue = function (_a) {
    var inputValue = _a.inputValue, isMulti = _a.isMulti, value = _a.value, setInputValue = _a.setInputValue, setPersistedInputValue = _a.setPersistedInputValue, setFilterTyping = _a.setFilterTyping;
    var valueCheck = '';
    if (!isMulti) {
        valueCheck = value && value.label ? value.label : '';
    }
    // if blur and input value !== value label, set it to value label
    if (!isMulti && inputValue !== valueCheck) {
        setInputValue(valueCheck);
    }
    if (isMulti) {
        setInputValue(valueCheck);
    }
    setPersistedInputValue('');
    setFilterTyping(false);
};
